module.exports = __webpack_public_path__ + "static/media/3.Plate Vibrator.ffc6b8c4.jpg";